import type { ReactNode, TdHTMLAttributes, ThHTMLAttributes } from "react";

type TableProps = {
  children: ReactNode;
  className?: string;
};

export function Table({ children, className = "" }: TableProps) {
  return (
    <div className="overflow-x-auto">
      <table className={`min-w-full divide-y divide-gray-200 ${className}`}>{children}</table>
    </div>
  );
}

type TableHeaderProps = {
  children: ReactNode;
  className?: string;
};

export function TableHeader({ children, className = "" }: TableHeaderProps) {
  return <thead className={`bg-gray-50 ${className}`}>{children}</thead>;
}

type TableBodyProps = {
  children: ReactNode;
  className?: string;
};

export function TableBody({ children, className = "" }: TableBodyProps) {
  return <tbody className={`divide-y divide-gray-200 bg-white ${className}`}>{children}</tbody>;
}

type TableRowProps = {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
};

export function TableRow({ children, className = "", onClick }: TableRowProps) {
  return (
    <tr
      className={`
        ${onClick ? "cursor-pointer hover:bg-gray-50" : ""}
        ${className}
      `}
      onClick={onClick}
    >
      {children}
    </tr>
  );
}

interface TableHeadProps extends ThHTMLAttributes<HTMLTableCellElement> {
  children?: ReactNode;
  className?: string;
}

export function TableHead({ children, className = "", ...props }: TableHeadProps) {
  return (
    <th
      className={`px-6 py-3 text-left font-medium text-gray-500 text-xs uppercase tracking-wider ${className}
      `}
      scope="col"
      {...props}
    >
      {children}
    </th>
  );
}

interface TableCellProps extends TdHTMLAttributes<HTMLTableCellElement> {
  children: ReactNode;
  className?: string;
}

export function TableCell({ children, className = "", ...props }: TableCellProps) {
  return (
    <td className={`whitespace-nowrap px-6 py-4 text-gray-900 text-sm ${className}`} {...props}>
      {children}
    </td>
  );
}
